import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import UserAvatar from '../../UserAvatar';

import './UserAvatarWithName.scss';

export default class UserAvatarWithName extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { test: true };
  }

  handleClick(e) {
    if (this.props.onClick) {
      this.props.onClick();
    }
    if (this.props.selectUser) {
      this.props.selectUser(this.props.user, e);
    }
    if (this.props.onClear) {
      this.props.onClear();
    }
  }

  render() {
    let { user, large } = this.props;
    let userName = ((user.last_name + ', ') || '') + (user.first_name || '');
    return (
      <div className="user-avatar-with-name" onClick={this.handleClick}>
        <div className="avatar">
          <UserAvatar id={'user-avatar-with-name' + user.id} key={'user-avatar-with-name' + user.id} user={user} large={large} />
        </div>
        <div className="user-name">{userName}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserAvatar/UserAvatarWithName/index.js